import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { RawIntlProvider, IntlContext } from 'react-intl';
import { getLanguageDirection } from '../utils/getLanguageDirection';
const I18nContext = React.createContext(null);
const { Provider } = I18nContext;
export const useI18n = () => {
    const intl = useContext(I18nContext);
    return intl;
};
export const I18nProvider = ({ children, i18n }) => {
    const { isDebugMode, debugFormatter } = useDebugMode();
    return (_jsx(RawIntlProvider, { value: i18n, children: _jsx(IntlContext.Consumer, { children: intl => {
                const $t = isDebugMode
                    ? debugFormatter(intl.formatMessage)
                    : intl.formatMessage;
                const localeCode = intl.locale || intl.defaultLocale;
                const languageDirection = getLanguageDirection(localeCode);
                return (_jsx(Provider, { value: {
                        localeCode,
                        languageDirection,
                        $t: $t,
                        formatList: intl.formatList,
                        formatDisplayName: intl.formatDisplayName,
                        getMessageByDynamicId: (id, defaultMessage) => {
                            if (intl.messages[id]) {
                                // We have already confirmed the existence of the message
                                // eslint-disable-next-line formatjs/enforce-default-message
                                return $t({ id });
                            }
                            return defaultMessage;
                        },
                    }, children: children }, void 0));
            } }, void 0) }, void 0));
};
/**
 * Enabling debug mode can break markup stylings. Use it only to validate
 * whether a certain string is passed through the translation layer or not.
 * Do not validate layout and other aspects of the UI with it.
 */
const useDebugMode = () => {
    if (typeof window === 'undefined' ||
        (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('i18n-debug-enabled')) !== 'true') {
        return {
            isDebugMode: false,
            debugFormatter: ($t) => $t,
        };
    }
    return {
        isDebugMode: true,
        debugFormatter: ($t) => {
            const debugCharEnd = (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('i18n-debug-char-end')) || ' ⦘';
            const debugCharStart = (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('i18n-debug-char-start')) || '⦗ ';
            return ((descriptor, values, opts) => {
                const message = $t(descriptor, values, opts);
                if (typeof message === 'string') {
                    return `${debugCharStart}${message}${debugCharEnd}`;
                }
                return [debugCharStart, ...message, debugCharEnd];
            });
        },
    };
};
//# sourceMappingURL=I18nProvider.js.map